var map = {
	"./dashboard.svg": "f782",
	"./dashboard_h.svg": "615b",
	"./file-mgr.svg": "57c8",
	"./file-mgr_h.svg": "1b89",
	"./metering.svg": "5f0e",
	"./metering_h.svg": "0029",
	"./resource-mgr.svg": "6738",
	"./resource-mgr_h.svg": "42c1",
	"./search.svg": "8e8d",
	"./share.svg": "5306",
	"./share_h.svg": "eed8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";